document.documentElement.classList.remove('no-js');

const body = document.body;
const drawer = document.querySelector('[data-mobile-drawer]');
const openDrawer = document.querySelector('[data-open-menu]');
const closeDrawer = document.querySelector('[data-close-menu]');

function setDrawer(open) {
  if (!drawer) return;
  drawer.classList.toggle('is-open', open);
  drawer.setAttribute('aria-hidden', String(!open));
  if (openDrawer) openDrawer.setAttribute('aria-expanded', String(open));
  body.style.overflow = open ? 'hidden' : '';
}
openDrawer?.addEventListener('click', () => setDrawer(true));
closeDrawer?.addEventListener('click', () => setDrawer(false));
drawer?.addEventListener('click', (event) => { if (event.target === drawer) setDrawer(false); });

const searchPanel = document.querySelector('[data-search-panel]');
function setSearch(open) {
  if (!searchPanel) return;
  searchPanel.classList.toggle('is-open', open);
  searchPanel.setAttribute('aria-hidden', String(!open));
  body.style.overflow = open ? 'hidden' : '';
  if (open) setTimeout(() => searchPanel.querySelector('input')?.focus(), 100);
}
document.querySelectorAll('[data-open-search]').forEach((button) => button.addEventListener('click', () => setSearch(true)));
document.querySelectorAll('[data-close-search]').forEach((button) => button.addEventListener('click', () => setSearch(false)));
searchPanel?.addEventListener('click', (event) => { if (event.target === searchPanel) setSearch(false); });

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') { setDrawer(false); setSearch(false); }
});

document.querySelectorAll('[data-faq-button]').forEach((button) => {
  button.addEventListener('click', () => {
    const item = button.closest('.faq-item');
    const isOpen = item.classList.toggle('is-open');
    button.setAttribute('aria-expanded', String(isOpen));
  });
});

document.querySelectorAll('[data-quantity]').forEach((wrapper) => {
  const input = wrapper.querySelector('input');
  wrapper.querySelector('[data-minus]')?.addEventListener('click', () => {
    input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  wrapper.querySelector('[data-plus]')?.addEventListener('click', () => {
    input.value = Number(input.value || 1) + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.1 }) : null;
document.querySelectorAll('[data-reveal]').forEach((element) => revealObserver ? revealObserver.observe(element) : element.classList.add('is-visible'));
